import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { InformationFolderComponent } from './information-folder.component';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  imports: [
    HeaderBarComponent,
    InformationFolderComponent,
  ],
})
export class InformationComponent {
  error?: HttpErrorResponse;
}
